import React, { Component } from 'react'
import classNames from 'classnames';
import CourseAttemptStatus from '../../enums/CourseAttemptStatus'
import { formatDate } from '../../actions/dateUtility';

import CourseProgress from './CourseProgress'
import { connect } from 'react-redux'
import HelpText from './HelpText'
import { getTooltipBySlug } from '../../services/reservoir'

const mapStateToProps = ({
  courses: { selectedCourseCode, data },
  course: { selectedCourse },
  currentUser
}) => {
  return {
    courseAttemptStatus: selectedCourse.courseAttemptStatus,
    courseCode: selectedCourseCode,
    courseTitle: selectedCourse.courseTitle,
    courseStage: selectedCourse.courseStage,
    userRole: currentUser.data['role']
  }
}

class EnrolmentsHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      courseProgressLoading: true,
      courseProgress: this.initialCourseProgress(),

      loadingTooltip: true,
      tooltip: ''
    }
  }

  componentDidMount() {
    this.setState({
      loadingTooltip: true
    })

    getTooltipBySlug('ecoe-date').then((tooltips = []) => {
      this.setState({
        tooltip:
          tooltips &&
          tooltips.length > 0 &&
          tooltips[0].attributes &&
          tooltips[0].attributes.field_body
            ? tooltips[0].attributes.field_body
            : this.state.tooltip,
        loadingTooltip: true
      })
    })
  }

  initialCourseProgress = () => ({
    completionPercentage: 0,
    electronicCoeEndDate: '',
    status: null,
    isEligibleToViewProgress: 'N',
    achievedAsCompleted: 0,
    achievedAsAdvanceStanding: 0,
    enrolledCP: 0,
    requiredToComplete: 0
    
  })

  handleCourseProgressLoadStart = () => {
    this.setState({
      courseProgressLoading: true,
      courseProgress: this.initialCourseProgress()
    })
  }

  handleCourseProgressLoadFinish = courseProgress => {
    this.setState({
      courseProgressLoading: false,
      courseProgress: courseProgress
    })
  }

  handleCourseProgressLoadFail = () => {
    this.setState({
      courseProgressLoading: false
    })
  }

  renderCourseTitle = () => {
    if (this.props.courseTitle) {
      if (this.props.courseCode) {
        return (
          <h2>
            {this.props.courseTitle} [{this.props.courseCode}]
          </h2>
        )
      }
      return <h2>{this.props.courseTitle}</h2>
    }

    return null
  }

  renderCongrats = () => {
    const completedCourse =
      this.props.courseAttemptStatus === CourseAttemptStatus.Completed

    return (
      <h3
        className={classNames('course-completed-msg', {
          'course-completed-msg--hidden': !completedCourse
        })}
      >
        <strong>Congratulations!</strong> You have successfully completed this
        course.
      </h3>
    )
  }

  renderECoEDate = () => {
    const showECoEDate =
      this.props.courseAttemptStatus !== CourseAttemptStatus.Completed &&
      this.state.courseProgress.isEligibleToViewProgress &&
      this.state.courseProgress.isEligibleToViewProgress === 'Y' &&
      this.state.courseProgress.electronicCoeEndDate

    //console.log("this.state.courseProgress.electronicCoeEndDate", this.state.courseProgress.electronicCoeEndDate);

    return (
      <HelpText
        className={classNames('ecoe-date', {
          'ecoe-date--active': showECoEDate
        })}
        tag="h3"
        toolTip={
          this.state.loadingTooltip && this.state.tooltip
            ? this.state.tooltip
            : ''
        }
        text={
          <span>
            eCoE end date:{' '}
            <strong>
            {this.state.courseProgress.electronicCoeEndDate
                ? formatDate(
                    this.state.courseProgress.electronicCoeEndDate,
                    'd MMM yyyy'
                  )
                : ''}
            </strong>
          </span>
        }
      />
    )
  }

  render() {
    if (this.props.userRole != 'STUDENT') {
      return null
    }

    return (
      <div className="container heading-container">
        <div
          className={classNames('heading-container__heading', {
            'heading-container__heading--active': !this.state.courseProgressLoading
          })}
        >
          <h1>{this.props.title}</h1>
          <div>
            {this.renderCourseTitle()}
            {this.renderCongrats()}
            {this.renderECoEDate()}
          </div>
        </div>

        <CourseProgress
          onLoadStart={this.handleCourseProgressLoadStart}
          onLoadFinish={this.handleCourseProgressLoadFinish}
          onLoadFail={this.handleCourseProgressLoadFail}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps)(EnrolmentsHeader)
